import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownFliterComponent } from 'src/app/components/dropdown-fliter/dropdown-fliter.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    DropdownFliterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
    MatDividerModule,
    MatMenuModule
  ],
  exports: [
    DropdownFliterComponent
  ]
})
export class DropdownFilterModule { }
